import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-add-button',
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.scss'],
  standalone: false
})
export class AddButtonComponent {

  @Input() text?: string;
  @Input() footerIsVisible: boolean = false;
  @Output() clickEvent: EventEmitter<any> = new EventEmitter();

  constructor() {}

  handleClick() {
    this.clickEvent.emit();
  }
}
